/* eslint-disable global-require */

module.exports = {
	guides: require("./guides.json"),
	updates: require("./updates.json"),
	common: require("./common.json"),
	series: require("./series.json"),
};
